export { UserAgentAspect, UserAgentAspect as default } from './user-agent.aspect';
export type { UserAgentUI } from './user-agent.ui.runtime';
